import LoyaltyBlock from './LoyaltyBlock'

export default LoyaltyBlock
